import React from "react";
import { Button } from "react-bootstrap";

import classNames from "classnames";

import { useGamesContext } from "../contexts/Games";
import { useButtonHandlers } from "../hooks/useButtonHandlers";

import { IGame, IUmpire } from "../../../../types/api";

const UmpireButton = ({
    game,
    location,
}: {
    game: IGame;
    location: IUmpire["location"];
}) => {
    const { umpirePay } = useGamesContext();
    const { handleBookingClick } = useButtonHandlers();
    const now = new Date();

    const umpire = game.umpires?.find(u => u.location === location);
    const pendingReplacement = game.umpires?.find(
        u => u.location === location && u.pendingReplacement,
    );
    const canCancel =
        pendingReplacement &&
        umpire?.cancelUntil &&
        now.getTime() < new Date(umpire?.cancelUntil).getTime();

    const showButton = umpirePay
        .find(u => u.ageLevel === game.ageLevel.ageLevel)
        ?.umpires.find(u =>
            location === "plate"
                ? u.title === "Plate Umpire" || u.title === "Umpire"
                : u.title === "Field Umpire",
        );

    return (
        <React.Fragment>
            {showButton && (
                <Button
                    variant={
                        umpire
                            ? !umpire.replacement
                                ? "primary"
                                : "warning"
                            : "danger"
                    }
                    className={classNames({
                        actionButton: true,
                        available: !umpire || !umpire.replacement,
                    })}
                    onClick={() => {
                        handleBookingClick(
                            game,
                            location,
                            pendingReplacement && canCancel
                                ? pendingReplacement
                                : umpire,
                            pendingReplacement && canCancel
                                ? umpire
                                : undefined,
                        );
                    }}
                >
                    {umpire ? (
                        pendingReplacement && canCancel ? (
                            <>
                                <s>{pendingReplacement.name}</s>
                                <br />
                                {umpire.name}
                            </>
                        ) : !umpire.replacement ? (
                            umpire.name
                        ) : (
                            <>
                                Replacement
                                <br />
                                {umpire.name}
                            </>
                        )
                    ) : (
                        "Available"
                    )}
                </Button>
            )}
        </React.Fragment>
    );
};

export default UmpireButton;
